import { STOCK_ERROR, STOCK_PRODUCTLIST } from '../Actions/ConfigStock.action';
import { error as errorReducer } from './Error.reducer';
const defaultState = {
    articlesList: [],
    errors: {}
}
export const articleStock = (state = defaultState, action) => {
    switch (action.type) {
        case STOCK_PRODUCTLIST:
            return {
                ...state,
                articlesList: action.payload.articlesList
            }
        case STOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}